import clsx from 'clsx'
import React, { FC } from 'react'
import {useIntl} from 'react-intl'
import { Status} from '../../core/_models'
import {getTrxStatusColor} from  '../../../_components/colors'

interface Props {
  states: Status[]
  scope: string
}

const States: FC<Props> = ({ states, scope }) => {
  const intl = useIntl()

  return (
    <div className="timeline">
      {(states || []).map((s: Status, index: number) => (
        <div key={`state-${index}`} className='timeline-item'>
          <div className='timeline-line w-40px'></div>

          <div className='timeline-icon symbol symbol-circle symbol-40px'>
            <div className='symbol-label'>
              <i className={clsx('fa fa-genderless fs-1', `text-${getTrxStatusColor(s.status)}`)}></i>
            </div>
          </div>

          <div className='timeline-content mb-5'>
            <div className='overflow-auto pe-3'>
              <div className={`badge badge-light-${getTrxStatusColor(s.status)} fw-semibold me-1`}>
                {intl.formatMessage({id: `P2C.${scope}_STATUS_${s.status}`})}
              </div>

              <div className='d-flex align-items-center fs-6'>
                <div className='text-muted me-2 fs-7'>
                  {intl.formatDate(s.date, {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default States
